export const AFFILIATE_PARTNER_LIST_REQUEST = 'AFFILIATE_PARTNER_LIST_REQUEST'
export const AFFILIATE_PARTNER_LIST_SUCCESS = 'AFFILIATE_PARTNER_LIST_SUCCESS'
export const AFFILIATE_PARTNER_LIST_FAIL = 'AFFILIATE_PARTNER_LIST_FAIL'
export const AFFILIATE_PARTNER_LIST_RESET = 'AFFILIATE_PARTNER_LIST_RESET'

export const AFFILIATE_PARTNER_CREATE_REQUEST = 'AFFILIATE_PARTNER_CREATE_REQUEST'
export const AFFILIATE_PARTNER_CREATE_SUCCESS = 'AFFILIATE_PARTNER_CREATE_SUCCESS'
export const AFFILIATE_PARTNER_CREATE_FAIL = 'AFFILIATE_PARTNER_CREATE_FAIL'
export const AFFILIATE_PARTNER_CREATE_RESET = 'AFFILIATE_PARTNER_CREATE_RESET'

export const AFFILIATE_PARTNER_GET_REQUEST = 'AFFILIATE_PARTNER_GET_REQUEST'
export const AFFILIATE_PARTNER_GET_SUCCESS = 'AFFILIATE_PARTNER_GET_SUCCESS'
export const AFFILIATE_PARTNER_GET_FAIL = 'AFFILIATE_PARTNER_GET_FAIL'
export const AFFILIATE_PARTNER_GET_RESET = 'AFFILIATE_PARTNER_GET_RESET'

export const AFFILIATE_PARTNER_UPDATE_REQUEST = 'AFFILIATE_PARTNER_UPDATE_REQUEST'
export const AFFILIATE_PARTNER_UPDATE_SUCCESS = 'AFFILIATE_PARTNER_UPDATE_SUCCESS'
export const AFFILIATE_PARTNER_UPDATE_FAIL = 'AFFILIATE_PARTNER_UPDATE_FAIL'
export const AFFILIATE_PARTNER_UPDATE_RESET = 'AFFILIATE_PARTNER_UPDATE_RESET'

export const AFFILIATE_PARTNER_DELETE_REQUEST = 'AFFILIATE_PARTNER_DELETE_REQUEST'
export const AFFILIATE_PARTNER_DELETE_SUCCESS = 'AFFILIATE_PARTNER_DELETE_SUCCESS'
export const AFFILIATE_PARTNER_DELETE_FAIL = 'AFFILIATE_PARTNER_DELETE_FAIL'

